import "./App.scss";

function App() {
  return <div className="App"></div>;
}

export default App;
